import { combineReducers, createReducer } from '@reduxjs/toolkit';

import type {
  AdvancementVersion,
  SSElectiveVersion,
} from '@appTypes/common/versions';
import { advancementTypes } from '@modules/shared/constants';

import {
  advancementVersionError,
  advancementVersionResponse,
  editAdvRqmtsError,
  editAdvRqmtsRequest,
  editAdvRqmtsResponse,
  editAdvRqmtsStopLoadingRequest,
  editAdvRqmtsStopLoadingSuccess,
} from './actionsTyped';
import reducers from './reducers';

const advReqEditLoading = createReducer(false, builder => {
  builder
    .addCase(editAdvRqmtsRequest, () => true)
    .addCase(editAdvRqmtsResponse, () => false)
    .addCase(editAdvRqmtsError, () => false);
});

const advReqEditStopLoading = createReducer(false, builder => {
  builder
    .addCase(editAdvRqmtsStopLoadingRequest, () => true)
    .addCase(editAdvRqmtsStopLoadingSuccess, () => false);
});

const advancementsVersions = createReducer(
  {} as Record<string, AdvancementVersion[]>,
  builder => {
    builder
      .addCase(advancementVersionResponse, (state, action) => {
        const {
          advancementType,
          advancementId,
          details: { versions },
        } = action.payload;
        const queryKey = `${advancementType}-${advancementId}`;
        let versionResults: AdvancementVersion[] =
          versions as AdvancementVersion[];
        // use ssVersionId as versionId for ssElectives
        if (advancementType === advancementTypes.SSELECTIVES) {
          versionResults = versions.map(version => {
            const ssElectiveVersion = version as SSElectiveVersion;
            return {
              ...ssElectiveVersion,
              versionId: ssElectiveVersion.ssVersionId ?? -1,
            } as AdvancementVersion;
          });
        }
        state[queryKey] = versionResults;
      })
      .addCase(advancementVersionError, (state, action) => {
        const { advancementType, advancementId } = action.payload;
        const queryKey = `${advancementType}-${advancementId}`;
        state[queryKey] = [];
      });
  },
);

export default combineReducers({
  ...reducers,
  advancementsVersions,
  advReqEditLoading,
  advReqEditStopLoading,
});
